<template>
  <div class="card-header">
    <p class="card-header-title">{{ title }}</p>
    <slot> </slot>
  </div>
</template>
<script>
export default {
  name: "CardHeader",
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>
